module.exports = __webpack_public_path__ + "static/media/saffron3_preview.db89c370.jpg";